import { render, staticRenderFns } from "./DeckCollections.vue?vue&type=template&id=21742b79"
import script from "./DeckCollections.vue?vue&type=script&lang=ts"
export * from "./DeckCollections.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports